// Role constants
export const ROLES = {
  ADMIN: 'ADMIN',
  EMPLOYEE: 'EMPLOYEE',
} as const;

// Employment type constants
export const EMPLOYMENT_TYPES = {
  CONTRACT: 'CONTRACT',
  FREELANCE: 'FREELANCE',
} as const;

export const INVOICE_NOTES = {
  DEFAULT: 'Total Payment Due: Within 30 days from invoice date',
} as const;

// Invoice status constants
export const INVOICE_STATUSES = {
  DRAFT: 'DRAFT',
  SENT: 'SENT',
  PAID: 'PAID',
  OVERDUE: 'OVERDUE',
  UNPAID: 'UNPAID',
} as const;

// Currency constants
export const CURRENCIES = {
  EUR: 'EUR',
  USD: 'USD',
  RSD: 'RSD',
  GBP: 'GBP',
  CHF: 'CHF',
} as const;

// Unit constants
export const UNITS = {
  HOUR: 'Hour',
  DAY: 'Day',
  MONTH: 'Month',
  PIECE: 'Piece',
  SERVICE: 'Service',
} as const;

// Employee positions
export const POSITIONS = [
  'Software Engineer',
  'UI/UX',
  'PO/PM',
  'Office Manager',
  'COO',
  'CEO',
  'CTO',
  'QA',
] as const;

// API endpoints
export const API_ENDPOINTS = {
  AUTH: {
    LOGIN: '/api/auth/login',
    LOGOUT: '/api/auth/logout',
    PROFILE: '/api/auth/profile',
    CHANGE_PASSWORD: '/api/auth/change-password',
  },
  EMPLOYEES: '/api/employees',
  CLIENTS: '/api/clients',
  PROJECTS: '/api/projects',
  INVOICES: '/api/invoices',
  TIMESHEETS: '/api/timesheets',
  TIME_OFF: '/api/time-off',
  REPORTS: '/api/reports',
  FILES: '/api/files',
  TECHNOLOGIES: '/api/technologies',
  HOLIDAYS: '/api/holidays',
} as const;

// Navigation paths
export const NAVIGATION = {
  ADD_CLIENT: '/clients/add',
  ADD_PROJECT: '/projects/add',
  ADD_INVOICE: '/invoices/add',
  ADD_EMPLOYEE: '/employees/add',
  DASHBOARD: '/dashboard',
  EMPLOYEES: '/employees',
  CLIENTS: '/clients',
  PROJECTS: '/projects',
  INVOICES: '/invoices',
  TIMESHEETS: '/timesheets',
  TIME_OFF: '/time-off',
  REPORTS: '/reports',
  PROFILE: '/profile',
  LOGIN: '/login',
} as const;

// Form validation messages
export const VALIDATION_MESSAGES = {
  REQUIRED: 'This field is required',
  EMAIL: 'Please enter a valid email address',
  MIN_LENGTH: (min: number) => `Must be at least ${min} characters`,
  MAX_LENGTH: (max: number) => `Must be no more than ${max} characters`,
  INVALID_FORMAT: 'Invalid format',
} as const;

// Success messages
export const SUCCESS_MESSAGES = {
  PASSWORD_CHANGED: 'Password changed successfully',
  PASSWORD_CHANGED_FOR_USER: (userName: string) => `Password changed successfully for ${userName}`,
} as const;

// Table configuration
export const TABLE_CONFIG = {
  DEFAULT_PAGE_SIZE: 25,
  PAGE_SIZE_OPTIONS: [25, 50, 100],
  ROWS_PER_PAGE: 25,
} as const;

// Date formats
export const DATE_FORMATS = {
  DISPLAY: 'dd.MM.yyyy.',
} as const;

// File types
export const FILE_TYPES = {
  PDF: 'application/pdf',
} as const;

// Storage keys
export const STORAGE_KEYS = {
  AUTH_TOKEN: 'token',
} as const;

// Lunch constants
export const LUNCH = {
  DEFAULT_PRICE: 550,
  CURRENCY: 'RSD',
  TABS: {
    DAILY_MENU: 'Daily Menu',
    ORDER: 'Order',
    ORDER_FOR_OTHER: 'Order for other',
    DAILY_ORDERS: 'Daily Orders',
    MONTHLY_SUMMARY: 'Monthly Summary',
  },
  MESSAGES: {
    SELECT_DATE_MENU: 'Choose a date to create or edit the lunch menu',
    SELECT_DATE_ORDER: 'Choose a date to view the menu and place your order',
    SELECT_DATE_EMPLOYEE_ORDER: 'Choose a date to place an order',
    SELECT_DATE_ORDERS: 'Choose a date to view all orders',
    SELECT_EMPLOYEE: 'Please select an employee to view the menu and place an order for them.',
    NO_MENU: 'No menu available for this date yet.',
    MENU_EMPTY: 'The menu for this date is empty.',
    NO_ORDERS: 'No orders placed for this date yet.',
    NO_ORDERS_MONTH: 'No orders found for this month.',
    ENTER_MENU_TEXT: 'Please enter menu text',
    SELECT_ONE_ITEM: 'Please select at least one item',
    MENU_SAVED: 'Menu saved successfully',
    ORDER_SAVED: 'Order saved successfully',
    ORDER_CANCELLED: 'Order cancelled successfully',
    ORDER_DELETED: 'Order deleted successfully',
    MENU_SAVE_ERROR: 'Failed to save menu',
    ORDER_SAVE_ERROR: 'Failed to save order',
    ORDER_CANCEL_ERROR: 'Failed to cancel order',
    ORDER_DELETE_ERROR: 'Failed to delete order',
    EXISTING_ORDER: 'This employee has an existing order for this date',
  },
  PLACEHOLDERS: {
    SELECT_EMPLOYEE: 'Type to search...',
  },
} as const;

// Export TimeOff constants
export * from './timeOff';
